import RefreshIcon from '@mui/icons-material/Refresh';
import { lighten } from '@mui/material';
import { IconButton, CircularProgress, Typography } from '@occc-app/design-system';

type InlineButtonProps = {
  isCalculating: boolean;
  hasCalculatedCount: boolean;
  isLoading: boolean;
  onCalculateOrRefresh: () => void;
};

export const InlineButton = ({
  isCalculating,
  hasCalculatedCount,
  isLoading,
  onCalculateOrRefresh,
}: InlineButtonProps) => {
  if (!isCalculating && !hasCalculatedCount) {
    return null;
  }

  if (isCalculating) {
    return (
      <Typography variant='body2' color='text.secondary' role='status' aria-live='polite'>
        It may take up to an hour
      </Typography>
    );
  }

  return (
    <IconButton
      onClick={isLoading ? undefined : onCalculateOrRefresh}
      disabled={isLoading}
      sx={(theme) => ({
        backgroundColor: lighten(theme.palette.primary.main, 0.8),
        borderRadius: theme.shape.borderRadius / 2,
        padding: theme.spacing(1),
        '&:hover': {
          backgroundColor: lighten(theme.palette.primary.main, 0.8),
          opacity: isLoading ? 0.6 : 0.8,
        },
        '&.Mui-disabled': {
          opacity: 0.6,
        },
      })}
    >
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <RefreshIcon sx={(theme) => ({ color: theme.palette.primary.main })} />
      )}
    </IconButton>
  );
};
